/**
 * PR-166: ID/REF validation for Recurring Payments subscription panel
 * - Max 100 characters
 * - Only A-Za-z0-9._:/- allowed (matches backend RegularExpression)
 */
export const RECURRING_PAYMENTS_SEARCH_MAX_LENGTH = 100;

const ID_REF_REGEX = /^[A-Za-z0-9._:/-]*$/;

/** Single character filter for ID/REF input (used when typing) */
export const recurringPaymentsSearchFilter = (char) =>
  /^[A-Za-z0-9._:/-]$/.test(char);

/** Validate full ID/REF value (used for paste and save) */
export const isValidIdRef = (value) => {
  if (value == null || typeof value !== 'string') return true;
  return value.length <= RECURRING_PAYMENTS_SEARCH_MAX_LENGTH && ID_REF_REGEX.test(value);
};
